import Layzr from 'layzr.js'
import { addClass, doesSupportObjectFit, closest, setStyle, getData } from 'modules/dom'

const instance = Layzr({
  threshold: 100
})

const disableObjectFit = addClass('no-object-fit')
const closestWrapper = closest('.js-wrap')
const setBgImg = (url, el) => setStyle('backgroundImage', `url(${url})`, el)
const objectFit = doesSupportObjectFit()
const loaded = addClass('image--loaded')

if (!objectFit) {
  disableObjectFit(document.body)
}

instance.on('src:after', img => {
  const wrapper = closestWrapper(img)

  if (!wrapper) {
    return
  }

  if (!objectFit) {
    const src = getData('normal', img)
    setBgImg(src, wrapper)
  }

  loaded(wrapper)
})

instance.update().check().handlers(true)

export default (el) => {

}
